import DefaultLayout from "@/components/DefaultLayout"
import FeaturedSection from "@/components/FeaturedSection"
import Head from "next/head"

export default function Topsellernew() {

  return (
    <>
      <Head>
        <title>Weekly Deals | Specials on Clearance Bargain Sale & Offers with Discounts Free Shipping Online</title>
        <meta name="keywords" content={`specials, sale, clearance sale, clearance, free shipping, bargain, discounts, weekly specials, deals, offers, hot deals, free shipping, price drop, hotdeals, weekly recommendation, weekly deals, bottom price, bargain sale`}></meta>
        <meta name="description" content={`Check out our selected weekly deals from zones of the clearance sale, bargain promotions, free shipping, and more. Do not miss out on these limited-time special offers and deep discounts. Shop now and save big!`}></meta>
        <meta name="format-detection" content="telephone=no" />
        <meta name="renderer" content="webkit" />
        <meta name="apple-mobile-web-app-title" content="Crazy Sales" />
      </Head>
      <DefaultLayout notStickyNavbar={true}>
        <FeaturedSection type="weekly-deals" />
      </DefaultLayout>
    </>

  )
}